import {
  AbsoluteCenter,
  Button as ChakraButton,
  Span,
  Spinner,
} from '@chakra-ui/react'
import * as React from 'react'

// Shared CTA recipes. Caller-provided props win over recipe defaults
// because the spread order is `...recipe, ..._hover_merged, ...rest`.
const TONE_RECIPES = {
  primary: {
    bg: 'gray.900',
    color: 'white',
    fontWeight: '600',
    borderRadius: 'xl',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    _hover: {
      bg: 'gray.800',
      boxShadow: '0 12px 24px -8px rgba(0,0,0,0.18)',
    },
  },
  destructive: {
    bg: 'red.600',
    color: 'white',
    fontWeight: '600',
    borderRadius: 'xl',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    _hover: {
      bg: 'red.700',
      boxShadow: '0 12px 24px -8px rgba(220, 38, 38, 0.25)',
    },
  },
}

export const Button = React.forwardRef(function Button(props, ref) {
  const { loading, disabled, loadingText, children, tone, ...rest } = props
  const recipe = tone ? TONE_RECIPES[tone] : null
  const merged = recipe
    ? {
        ...recipe,
        ...rest,
        // Merge _hover so caller overrides specific keys without losing the rest.
        _hover: { ...recipe._hover, ...(rest._hover || {}) },
      }
    : rest
  return (
    <ChakraButton disabled={loading || disabled} ref={ref} {...merged}>
      {loading && !loadingText ? (
        <>
          <AbsoluteCenter display='inline-flex'>
            <Spinner size='inherit' color='inherit' />
          </AbsoluteCenter>
          <Span opacity={0}>{children}</Span>
        </>
      ) : loading && loadingText ? (
        <>
          <Spinner size='inherit' color='inherit' />
          {loadingText}
        </>
      ) : (
        children
      )}
    </ChakraButton>
  )
})
